import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./AccountStatus.css";
// import "../../../src/App.css";
import { TbCoin } from "react-icons/tb";
import {
  MdOutlineReplay,
  MdOutlineSettings,
  MdAccountBalanceWallet,
} from "react-icons/md";
import { GiWallet } from "react-icons/gi";
import { useNavigate } from "react-router-dom";
import { IoReorderThree } from "react-icons/io5";
import { GrCurrency } from "react-icons/gr";
import { RiPagesLine } from "react-icons/ri";
import { FaBook, FaLock } from "react-icons/fa";
import { IoMdSettings } from "react-icons/io";
import { LuLogOut } from "react-icons/lu";
import { ImProfile } from "react-icons/im";
import LoginPopup from "../LoginPopup/LoginPopup";
import Login from "../Login/Login";
import SignUp from "../SignUp/SignUp";
import DepositWithdraw from "../DepositWithdraw";

const AccountStatus = (props) => {
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const navigate = useNavigate();

  const [showPopup, setShowPopup] = useState(false);
  const [showSignupPopup, setShowSignupPopup] = useState(false);

  // Function to navigate to the given path
  const navigateTo = (path) => {
    navigate(path);
  };

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  const toggleSignUpPopup = () => {
    setShowSignupPopup(!showSignupPopup);
  };

  return (
    <>
      <Login
        showPopup={showPopup}
        togglePopup={togglePopup}
        handleClose={props.handleClose}
      />
      <SignUp
        showSignupPopup={showSignupPopup}
        toggleSignUpPopup={toggleSignUpPopup}
        handleClose={props.handleClose}
      />
      <div className="main-section">
        <div className="section-second">
          <nav className="navbar-account">
            <button type="button" className="btn btn-dark bet">
              <TbCoin size={25} color="white" style={{ marginRight: 0 }} />
              Bets
            </button>
            {/* <button type="button" className="btn btn-dark replay">
            <MdOutlineReplay size={25} color="white" style={{ marginRight: 0 }} />
          </button> */}
            <button
              type="button"
              className="btn btn-dark setting"
              onClick={() => navigateTo("/settings")}
            >
              <MdOutlineSettings
                size={25}
                color="white"
                style={{ marginRight: 0 }}
              />
            </button>
          </nav>
          {props?.userInfo ? (
            <nav
              className="navbar-small flex my-2"
              // style={{ display: "", height: "6vh", paddingTop: "2vw" }}
            >
              {/* <button
                className="button-83"
                role="button"
                onClick={() => navigateTo("/deposit")}
              >
                Deposit{" "}
                <MdAccountBalanceWallet
                  size={25}
                  color="white"
                  style={{ marginRight: 0, marginLeft: 0 }}
                />
              </button>
              <button
                className="withdraw"
                role="button"
                onClick={() => navigateTo("/withdraw")}
              >
                Withdraw{" "}
                <GiWallet size={25} color="white" style={{ marginRight: 0 }} />
              </button> */}
              <DepositWithdraw />
            </nav>
          ) : (
            <nav className="navbar-small">
              <button
                className="pushable-login submit-btn login-trigger "
                onClick={() => togglePopup()}
              >
                <span className="front-login">Login</span>
              </button>
              <button
                className="pushable-signup submit-btn login-trigger "
                onClick={() => toggleSignUpPopup()}
                style={{ width: "auto" }}
              >
                <span
                  className="front-signup"
                  style={{
                    width: "auto",
                    paddingTop: 10,
                    paddingBottom: 10,
                    paddingLeft: 15,
                    paddingRight: 15,
                    fontSize: 20,
                  }}
                >
                  Sign Up
                </span>
              </button>
            </nav>
          )}

          <div className="vertical-navbar">
            <ul>
              <li>
                <button
                  className="ac-button flex"
                  onClick={() => navigateTo("/openbets")}
                >
                  <div className="flex items-center justify-start">
                    <IoReorderThree className="icon-button mr-2" />
                    <span> Open Bets </span>
                  </div>
                </button>
              </li>
              <li>
                <button
                  className="ac-button"
                  onClick={() => navigateTo("/profitandloss")}
                >
                  <div className="flex items-center justify-start">
                    <GrCurrency className="icon-button mr-2" />
                    <span> Profit And Loss </span>
                  </div>
                </button>
              </li>
              <li>
                <button
                  className="ac-button"
                  onClick={() => navigateTo("/accountstatement")}
                >
                  <div className="flex items-center justify-start">
                    <RiPagesLine className="icon-button mr-2" />{" "}
                    <span>Account Statement </span>
                  </div>
                </button>
              </li>
              <li>
                <button
                  className="ac-button flex"
                  onClick={() => navigateTo("/profile")}
                >
                  <div className="flex items-center justify-start">
                    <ImProfile className="icon-button mr-2" />
                    <span>My Profile </span>
                  </div>
                </button>
              </li>
              <li>
                <button
                  className="ac-button flex"
                  onClick={() => navigateTo("/referandearn")}
                >
                  <div className="flex items-center justify-start">
                    <ImProfile className="icon-button mr-2" />{" "}
                    <span>Refer & Earn </span>
                  </div>
                </button>
              </li>
              <li>
                <button
                  className="ac-button flex"
                  onClick={() => navigateTo("/rules")}
                >
                  <div className="flex items-center justify-start">
                    <FaBook className="icon-button mr-2" />
                    <span>Rules </span>
                  </div>
                </button>
              </li>
              <li>
                <button
                  className="ac-button flex"
                  onClick={() => navigateTo("/changepassword")}
                >
                  <div className="flex items-center justify-start">
                    <FaLock className="icon-button mr-2" />{" "}
                    <span>Change Password </span>
                  </div>
                </button>
              </li>
              <li>
                <button
                  className="ac-button flex"
                  onClick={() => navigateTo("/settings")}
                >
                  <div className="flex items-center justify-start">
                    <IoMdSettings className="icon-button mr-2" />{" "}
                    <span>Settings </span>
                  </div>
                </button>
              </li>
            </ul>
          </div>
          {showLoginPopup && (
            <LoginPopup onClose={() => setShowLoginPopup(false)} />
          )}
          {props?.userInfo && (
            <button
              type="button"
              className="btn btn-danger account"
              onClick={() => props?.handleLogout()}
            >
              <div className="flex items-center justify-center">
                <span>Logout </span>
                <LuLogOut size={25} color="white" style={{ marginLeft: 10 }} />
              </div>
            </button>
          )}
        </div>
      </div>
    </>
  );
};

export default AccountStatus;
